import { AudioTrackId } from '../../domain/models';

/**
 * Maps every AudioTrackId to its public URL path (served from /audio/).
 * Audio files live in packages/assets/audio/ and are copied to dist/audio/ at build time.
 */
export const AUDIO_TRACK_REGISTRY: Record<AudioTrackId, string> = {
  // Countdown numbers
  [AudioTrackId.n01]: '/audio/1.m4a',
  [AudioTrackId.n02]: '/audio/2.m4a',
  [AudioTrackId.n03]: '/audio/3.m4a',
  [AudioTrackId.n04]: '/audio/4.m4a',
  [AudioTrackId.n05]: '/audio/5.m4a',
  [AudioTrackId.n06]: '/audio/6.m4a',
  [AudioTrackId.n07]: '/audio/7.m4a',
  [AudioTrackId.n08]: '/audio/8.m4a',
  [AudioTrackId.n09]: '/audio/9.m4a',
  [AudioTrackId.n10]: '/audio/10.m4a',
  [AudioTrackId.n11]: '/audio/11.m4a',
  [AudioTrackId.n12]: '/audio/12.m4a',
  [AudioTrackId.n13]: '/audio/13.m4a',
  [AudioTrackId.n14]: '/audio/14.m4a',
  [AudioTrackId.n15]: '/audio/15.m4a',
  [AudioTrackId.n16]: '/audio/16.m4a',
  [AudioTrackId.n17]: '/audio/17.m4a',
  [AudioTrackId.n18]: '/audio/18.m4a',
  [AudioTrackId.n19]: '/audio/19.m4a',
  [AudioTrackId.n20]: '/audio/20.m4a',
  [AudioTrackId.n21]: '/audio/21.m4a',
  [AudioTrackId.n22]: '/audio/22.m4a',
  [AudioTrackId.n23]: '/audio/23.m4a',
  [AudioTrackId.n24]: '/audio/24.m4a',
  [AudioTrackId.n25]: '/audio/25.m4a',
  [AudioTrackId.n26]: '/audio/26.m4a',
  [AudioTrackId.n27]: '/audio/27.m4a',
  [AudioTrackId.n28]: '/audio/28.m4a',
  [AudioTrackId.n29]: '/audio/29.m4a',
  [AudioTrackId.n30]: '/audio/30.m4a',

  // Music
  [AudioTrackId.meditationMusic]: '/audio/meditation-relaxing-music-DanaMusic.mp3',

  // Breathing commands (voice over)
  [AudioTrackId.getReady]: '/audio/get-ready.mp3',
  [AudioTrackId.inhaleMouth]: '/audio/inhale-mouth.mp3',
  [AudioTrackId.inhaleNose]: '/audio/inhale-nose.mp3',
  [AudioTrackId.inhaleSmoothly]: '/audio/inhale-smoothly.mp3',
  [AudioTrackId.inhaleWordFast]: '/audio/inhale-word-fast.mp3',
  [AudioTrackId.inFast]: '/audio/in-fast.mp3',
  [AudioTrackId.exhaleWordFast]: '/audio/exhale-word-fast.mp3',
  [AudioTrackId.outFast]: '/audio/out-fast.mp3',
  [AudioTrackId.inhaleLeft]: '/audio/inhale-left.mp3',
  [AudioTrackId.inhaleRight]: '/audio/inhale-right.mp3',
  [AudioTrackId.exhaleLeft]: '/audio/exhale-left.mp3',
  [AudioTrackId.exhaleRight]: '/audio/exhale-right.mp3',
  [AudioTrackId.exhaleWordBee]: '/audio/exhale-word-bee.mp3',
  [AudioTrackId.inhaleTongue]: '/audio/inhale-tongue.mp3',
  [AudioTrackId.exhaleThroughNose]: '/audio/exhale-through-nose.mp3',
  [AudioTrackId.exhaleThroughMouth]: '/audio/exhale-through-mouth.mp3',
  [AudioTrackId.inhaleWord]: '/audio/inhale-word.mp3',
  [AudioTrackId.exhaleMurcha]: '/audio/exhale-murcha.m4a',
  [AudioTrackId.swallowAndHold]: '/audio/swallow-and-hold.m4a',
  [AudioTrackId.exhaleWord]: '/audio/exhale-word.mp3',
  [AudioTrackId.hold]: '/audio/hold.mp3',
  [AudioTrackId.holdFemale]: '/audio/hold-female.m4a',
  [AudioTrackId.inhale70Percent]: '/audio/inhale-70-percent.mp3',
  [AudioTrackId.exhaleCount8]: '/audio/exhale-count-8.mp3',
  [AudioTrackId.holdBreathCount7]: '/audio/hold-breath-count-7.mp3',
  [AudioTrackId.inhaleQuietlyCount4]: '/audio/inhale-quietly-count-4.mp3',

  // Ujjayi breathing sounds
  [AudioTrackId.exhaleSoundUjjayi2Sec]: '/audio/exhale-ujjayi-sound-2-sec.wav',
  [AudioTrackId.exhaleSoundUjjayi4Sec]: '/audio/exhale-ujjayi-sound-4-sec.wav',
  [AudioTrackId.inhaleSoundUjjayi2Sec]: '/audio/inhale-ujjayi-sound-2-sec.wav',
  [AudioTrackId.inhaleSoundUjjayi4Sec]: '/audio/inhale-ujjayi-sound-4-sec.wav',

  // Generic voice overs
  [AudioTrackId.breathworkPrep1]: '/audio/breathwork-prep-1.mp3',
  [AudioTrackId.breathworkPrep2]: '/audio/breathwork-prep-2.mp3',
  [AudioTrackId.breathworkClosing]: '/audio/breathwork-closing.mp3',
  [AudioTrackId.roundClosing]: '/audio/round-closing.mp3',
  [AudioTrackId.roundStartPrep]: '/audio/round-start-prep.mp3',
  [AudioTrackId.takeFewDeepBreathsPrepTalk]: '/audio/take-few-breaths-prep-talk.mp3',

  // Breathing sounds
  [AudioTrackId.exhaleSound300ms]: '/audio/exhale-sound-300ms.wav',
  [AudioTrackId.exhaleSound02Sec]: '/audio/exhale-sound-02-sec.wav',
  [AudioTrackId.exhaleSound04Sec]: '/audio/exhale-sound-04-sec.wav',
  [AudioTrackId.exhaleSound06Sec]: '/audio/exhale-sound-06-sec.wav',
  [AudioTrackId.exhaleSound08Sec]: '/audio/exhale-sound-08-sec.wav',
  [AudioTrackId.exhaleSound12Sec]: '/audio/exhale-sound-12-sec.wav',
  [AudioTrackId.exhaleSound20Sec]: '/audio/exhale-sound-20-sec.wav',
  [AudioTrackId.exhaleSound30Sec]: '/audio/exhale-sound-30-sec.wav',
  [AudioTrackId.exhaleSoundKapalabhati]: '/audio/kapalabhati-exhale.wav',
  [AudioTrackId.inhaleSound300ms]: '/audio/inhale-sound-300ms.wav',
  [AudioTrackId.inhaleSound02Sec]: '/audio/inhale-sound-02-sec.wav',
  [AudioTrackId.inhaleSound04Sec]: '/audio/inhale-sound-04-sec.wav',
  [AudioTrackId.inhaleSound06Sec]: '/audio/inhale-sound-06-sec.wav',
  [AudioTrackId.inhaleSound08Sec]: '/audio/inhale-sound-08-sec.wav',
  [AudioTrackId.inhaleSound12Sec]: '/audio/inhale-sound-12-sec.wav',
  [AudioTrackId.inhaleSound20Sec]: '/audio/inhale-sound-20-sec.wav',
  [AudioTrackId.inhaleSound30Sec]: '/audio/inhale-sound-30-sec.wav',
  [AudioTrackId.exhaleSoundBee15Sec]: '/audio/exhale-bee-sound-15-sec.wav',
  [AudioTrackId.exhaleSoundBee30Sec]: '/audio/exhale-bee-sound-30-sec.wav',

  // Bhastrika
  [AudioTrackId.sitComfortableSpineStraightShouldersRelaxedGazeForwardPrep]:
    '/audio/sit-comfortable-spine-straight-shoulders-relaxed-gaze-forward.mp3',
  [AudioTrackId.placePalmsOnKneesPrep]: '/audio/place-palms-on-knees-prep.mp3',
  [AudioTrackId.bhastrikaPrep1]: '/audio/bhastrika-prep-1.mp3',
  [AudioTrackId.bhastrikaExhale]: '/audio/bhastrika-exhale.wav',
  [AudioTrackId.bhastrikaInhale]: '/audio/bhastrika-inhale.wav',

  // Kapalabhati
  [AudioTrackId.kapalabhatiPrep3]: '/audio/kapalabhati-prep-3.mp3',

  // Bhramari
  [AudioTrackId.bhramariPrep1]: '/audio/bhramari-prep-1.mp3',

  // Ujjayi
  [AudioTrackId.sitComfortablyInPositionOfYourChoiceWithYourSpineStraightAndShouldersRelaxedPrep]:
    '/audio/sit-comfortably-in-position-of-your-choice-with-your-spine-straight-and-shoulders-relaxed.mp3',
  [AudioTrackId.takeAFewNaturalBreathsSettleYourMindAndBody]:
    '/audio/take-a-few-natural-breaths-settle-your-mind-and-body.mp3',
  [AudioTrackId.ujjayiPrep1]: '/audio/ujjayi-prep-1.mp3',
  [AudioTrackId.ujjayiPrep2]: '/audio/ujjayi-prep-2.mp3',
  [AudioTrackId.sitQuietlyEyesClosedBreathToItsNaturalRhythm]:
    '/audio/sit-quietly-eyes-closed-breath-to-its-natural-rhythm.mp3',
  [AudioTrackId.takeFewMinutesHowBodyFeelsEnergizedClearPresent]:
    '/audio/take-few-minutes-how-body-feels-energized-clear-present.mp3',

  // Nadi Shodhana
  [AudioTrackId.sitComfortableSpineStraightShouldersRelaxedLeftHandOnKneeChinMudraPrep]:
    '/audio/sit-comfortable-spine-straight-shoulders-relaxed-left-hand-on-knee-chin-mudra.mp3',
  [AudioTrackId.closeYourEyesAndCenterYourself]: '/audio/close-your-eyes-and-center-yourself.mp3',
  [AudioTrackId.nadiShodanaPrep1]: '/audio/nadi-shodhana-prep-1.mp3',
  [AudioTrackId.nadiShodanaPrep2]: '/audio/nadi-shodhana-prep-2.mp3',
  [AudioTrackId.nadiShodanaPrep3]: '/audio/nadi-shodhana-prep-3.mp3',
  [AudioTrackId.nadiShodanaCompletion]: '/audio/nadi-shodana-completion1.mp3',

  // Anulom Vilom
  [AudioTrackId.anulomVilomPrep2]: '/audio/anulom-vilom-prep-2.mp3',
  [AudioTrackId.anulomVilomPrep3]: '/audio/anulom-vilom-prep-3.mp3',

  // Sitali
  [AudioTrackId.sitComfortableSpineStraightRelaxHandsOnKnees]:
    '/audio/sit-comfortable-spine-straight-relax-shoulders-hands-on-knees-thighs.mp3',
  [AudioTrackId.keepChestOpenBodyRelaxedAlertCloseEyesDeepBreathsCenterFocus]:
    '/audio/keep-chest-open-body-relaxed-alert-close-eyes-deep-breaths-center-focus.mp3',
  [AudioTrackId.sitaliPrep1]: '/audio/sitali-prep-1.mp3',
  [AudioTrackId.sitaliPrep2]: '/audio/sitali-prep-2.mp3',
  [AudioTrackId.takeFewMinutesHowBodyFeelsCoolerRefreshedRelaxed]:
    '/audio/take-few-minutes-how-body-feels-cooler-refreshed-relaxed.mp3',

  // Sitkari
  [AudioTrackId.sitkariPrep1]: '/audio/sitkari-prep-1.mp3',
  [AudioTrackId.sitkariPrep2]: '/audio/sitkari-prep-2.mp3',

  // Surya / Chandra Bhedana
  [AudioTrackId.suryaBhedanaPrep1]: '/audio/surya-bheadana-prep-1.mp3',
  [AudioTrackId.maintainRhythmicBreathingPattern]: '/audio/maintain-rhythmic-breathing-pattern.mp3',
  [AudioTrackId.chandraBedhanaPrep1]: '/audio/chandra-bhedana-prep-1.mp3',

  // Murcha
  [AudioTrackId.murchaPrep1]: '/audio/murcha-prep-3.mp3',
  [AudioTrackId.murchaPrep2]: '/audio/murcha-prep-4.mp3',
  [AudioTrackId.murchaPrep3]: '/audio/murcha-prep-5.mp3',

  // Tummo
  [AudioTrackId.tummoPrep1]: '/audio/tummo-prep-3.mp3',
  [AudioTrackId.tummoPrep2]: '/audio/tummo-prep-4.mp3',
  [AudioTrackId.tummoPrep3]: '/audio/tummo-prep-5.mp3',

  // Khechari Mudra
  [AudioTrackId.khechariMudraPrep1]: '/audio/khechari-mudra-prep-1.mp3',
  [AudioTrackId.khechariMudraPrep2]: '/audio/khechari-mudra-prep-2.mp3',
  [AudioTrackId.khechariMudraPrep3]: '/audio/khechari-mudra-prep-3.mp3',
  [AudioTrackId.khechariMudraPrep4]: '/audio/khechari-mudra-prep-4.mp3',

  // Kumbhaka
  [AudioTrackId.kumbhakaPrep1]: '/audio/kumbhaka-prep-1.mp3',
  [AudioTrackId.kumbhakaPrep2]: '/audio/kumbhaka-prep-2.mp3',
  [AudioTrackId.kumbhakaPrep3]: '/audio/kumbhaka-prep-3.mp3',
  [AudioTrackId.kumbhakaPrep4]: '/audio/kumbhaka-prep-4.mp3',

  // Plavini
  [AudioTrackId.plaviniPrep1]: '/audio/plavini-prep-3.mp3',
  [AudioTrackId.plaviniPrep2]: '/audio/plavini-prep-4.mp3',
  [AudioTrackId.plaviniPrep3]: '/audio/plavini-prep-5.mp3',

  // Sama Vritti
  [AudioTrackId.samaVritti3]: '/audio/sama-vritti-prep-3.mp3',
  [AudioTrackId.samaVritti4]: '/audio/sama-vritti-prep-4.mp3',
  [AudioTrackId.samaVritti5]: '/audio/sama-vritti-prep-5.mp3',

  // Vishama Vritti
  [AudioTrackId.vishamaVrittiPrep1]: '/audio/vishama-vritti-prep-3.mp3',
  [AudioTrackId.vishamaVrittiPrep2]: '/audio/vishama-vritti-prep-4.mp3',

  // 4-7-8
  [AudioTrackId.sitComfortablyOrLieDown]: '/audio/sit-comfortably-or-lie-down.mp3',
  [AudioTrackId.closeYourEyesSettleBodyCalmMind]: '/audio/close-your-eyes-settle-body-calm-mind.mp3',

  // Metronome
  [AudioTrackId.metronome]: '/audio/metronome.mp3',
};

export function getAudioUrl(trackId: AudioTrackId): string {
  return AUDIO_TRACK_REGISTRY[trackId];
}
